import { render, staticRenderFns } from "./add_pick.vue?vue&type=template&id=11bb81f4&scoped=true&"
import script from "./add_pick.vue?vue&type=script&lang=js&"
export * from "./add_pick.vue?vue&type=script&lang=js&"
import style0 from "./add_pick.vue?vue&type=style&index=0&id=11bb81f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb81f4",
  null
  
)

export default component.exports